require('./vsko-tag.css');

var vskoTag = angular.module('vskoTag', []);

vskoTag.directive('vskoTagList', [function () {
  'use strict';

  return {
    restrict: 'A',
    template: require('./vsko-tag-list.html'),
    replace: true,
    transclude: true,
    scope: {},
    link: function ($scope, element, attrs) {
    }
  };
}]);

vskoTag.directive('vskoTag', [function () {
  'use strict';

  return {
    restrict: 'E',
    template: require('./vsko-tag.html'),
    replace: true,
    transclude: true,
    scope: {
      removable: '=',
      removeFunc: '&?removeFunction',
      tagKey: '@?'
    },
    link: function ($scope) {

      $scope.removeTag = function () {
        if ($scope.tagKey) {
          $scope.removeFunc({key: $scope.tagKey});
        }
      };
    }
  };
}]);

vskoTag.directive('vskoTagLabel', [function () {
  'use strict';

  return {
    restrict: 'A',
    template: require('./vsko-tag-label.html'),
    replace: true,
    transclude: true,
    scope: {},
    link: function ($scope, element, attrs) {
    }
  };
}]);
